import { TransactionData } from '@/modules/transaction/services/exchange';

const DEFAULT_TRANSACTION_DATA: TransactionData = {
  status: 'scheduled',
  natureOperationCode: 0,
  operationNatureDescription: '',
  symbolBaseCurrency: '',
  symbolCurrencyQuote: '',
  tradedCurrencyAmount: 0,
  netValue: 0,
  bankName: '',
  acronymCountryBank: '',
  bankSWIFTCode: '',
  bankABACode: '',
  beneficiaryName: '',
  beneficiaryAccount: '',
  forFurtherCreditName: '',
  forFurtherCreditAccount: ''
};

export default DEFAULT_TRANSACTION_DATA;
